export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openEmailTemplateForm({commit}) {
        commit('setEmailTemplateFormOpen');
    },
    closeEmailTemplateForm({commit}) {
        commit('setEmailTemplateFormClose');
    },
    openUniqueDurationForm({commit}) {
        commit('setUniqueDurationFormOpen');
    },
    closeUniqueDurationForm({commit}) {
        commit('setUniqueDurationFormClose');
    }
}
